import { useEffect, useRef } from "react";
import { api, setToken } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sid) { window.location.replace("/login"); return; }
    api.post("/auth/session", { session_id: sid })
      .then((r) => {
        setToken(r.data.token);
        window.location.replace("/");
      })
      .catch(() => window.location.replace("/login"));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F7F9]" data-testid="auth-callback">
      <div className="text-[14px] text-[--idc-muted]">Connexion en cours…</div>
    </div>
  );
}
